import styled from 'styled-components';
import { Flex } from 'dash-ui';

export const ButtonContainer = styled(Flex)`
  visibility: hidden;
  width: 0px;
  @media ${({ theme }) => theme.devices.mobile} {
    width: auto;
    visibility: visible;
    margin-right: ${({ theme }) => theme.space * 4}px;
  }
`;

export const SelectContainer = styled(Flex)`
  width: 100%;
  visibility: visible;
`;
